var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGraven = function SvgGraven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0L0 50l50 50 50-50zm0 2.777l47.225 47.225L50 97.225 2.775 50.002zm0 2.677L5.454 50.002 50 94.548l44.546-44.546L50 5.454zm0 6.945l37.601 37.603L50 87.603 12.399 50.002 50 12.399zM49.212 27.7v1.765h-2.438v1.578h2.438v2.49L35.633 44.721l1.69 2.05L50 36.326l12.677 10.446 1.69-2.05-13.579-11.189v-2.489h2.438v-1.578h-2.438V27.7zM50 37.923l-9.96 8.26v14.041h6.542v-5.953a3.378 3.378 0 013.38-3.38h.076a3.378 3.378 0 013.38 3.38v5.953h6.541v-14.04L50 37.923zM38.913 49.747l-6.379 3.696v6.816h6.379V49.747zm22.174.007V60.26h6.379v-6.816z",
    fill: "#f0cf75",
    fillOpacity: 1,
    strokeWidth: 0.036
  })));
};

export default SvgGraven;